import { themeVar as colors } from "../design-tokens";
import { NOT_AVAILABLE_LINE } from "./api";
import { useMlsMe, useMlsOffered } from "./useMlsOffered";

/**
 * A plain-text MLS status row on the comp step (Release 1.1 Slice A). Never a button: there is
 * nothing for the agent to press here.
 *
 * DARK MEANS ABSENT. While the server flag is off (`/api/mls-access/*` 404s) this renders
 * NOTHING, so with the flag off the comp step is exactly the CAD-fix build's.
 *
 * Flag on: when the server's cascade says the MLS rung is available for this user
 * (`gates.mls.available === true`) the row is hidden, because the MLS rows themselves are the
 * signal. Otherwise it prints the server's own sentence for THIS user: the first missing condition
 * of the four-part gate, or "MLS: not available on your account." for anyone outside the NTREIS
 * group. The client never composes the reason itself.
 */
export function CompMlsRow({ available }: { available?: boolean | null }) {
  const offered = useMlsOffered();
  const me = useMlsMe();
  // Nothing until the server has answered: a guessed sentence would tell a member "not available".
  if (!offered || available === true || me === null) return null;
  const line = me.member ? (me.gate.reason || me.explanation) : NOT_AVAILABLE_LINE;
  return (
    <p data-testid="comp-mls-row"
       style={{ marginTop: 6, fontSize: 13, lineHeight: 1.5, color: colors.textSecondary }}>
      {line}
    </p>
  );
}
